


















































































































































































































































































































































import { Component, Vue, Watch } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import * as _ from "lodash";
import {
  ContactInformation,
  FetchState,
  HsabSsoDestination,
  LoginMethod,
  maritalStatusDisplayMap,
  EmployerEmployeeProfileSettingValue,
  DrivewealthWizardStep,
  DrivewealthAccountSummary
} from "@/shared/types";
import NoAccountMessage from "@/employee/components/NoAccountMessage.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserPlanStore } from "@/employee/store/userPlan";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useThemeStore } from "@/shared/store/theme";
import { useUserStore } from "@/shared/store/user";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import EditProfile from "@/employee/components/settings/profile/EditProfile.vue";
import AccountInfoTabs from "@/employee/components/settings/profile/AccountInfoTabs.vue";
import { useHsaLimitStore } from "@/shared/store/hsalimit";
import EditCoverageLevel from "@/employee/components/settings/profile/EditCoverageLevel.vue";
import HsaInvestAccountList from "@/employee/components/settings/profile/HsaInvestAccountList.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useNotifierStore } from "@/shared/store/notifier";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import Dependents from "@/employee/components/settings/profile/Dependents.vue";

const initialState: ContactInformation = {
  firstName: "",
  middleInitial: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  mobilePhoneNumber: "",
  isMailingSameAsPhysical: false,
  dateOfBirth: "",
  mailingAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: ""
  },
  physicalAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: ""
  },
  lastFourSsn: "",
  memberNumber: "",
  lastLogin: "",
  username: ""
};

const passwordInitialState = {
  currentPassword: "",
  newPassword: "",
  newPasswordVerify: ""
};

const editProfileDisabledMessage = "Editing has been disabled by your employer. Please contact your employer directly to make changes.";

@Component({
  components: {
    NoAccountMessage,
    Input,
    SettingsNavigation,
    SettingsHeader,
    GenericLoadingSpinner,
    SsoDeepLink,
    EditProfile,
    AccountInfoTabs,
    EditCoverageLevel,
    HsaInvestAccountList,
    Dependents
  }
})
export default class MyProfileDisplay extends Vue {
  $validator: Validator;
  DrivewealthWizardStep = DrivewealthWizardStep;

  userBankAccountStore = useUserBankAccountStore();
  themeStore = useThemeStore();
  custodianSettingsStore = useCustodianSettingsStore();
  userPlanStore = useUserPlanStore();
  contactInfoStore = useContactInfoStore();
  partnerPortal = usePartnerPortalStore();
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  featureFlagStore = useFeatureFlagStore();
  hsaLimitStore = useHsaLimitStore();
  bankAccountStore = useBankAccountStore();
  drivewealthStore = useDrivewealthStore();
  signingDocumentStore = useSigningDocumentStore();
  notifierStore = useNotifierStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  hsabInvestmentStore = useHsabInvestmentStore();

  isBankMasked = true;
  formModel: ContactInformation = { ...initialState };
  isSubmitting = false;
  showEmailChangeModal = false;
  editEmailMode = false;
  editUsernameMode = false;
  updatingUsername = false;
  passwordFormModel = { ...passwordInitialState };
  editPasswordMode = false;
  updatingPassword = false;
  showPasswordRequirements = false;
  maritalStatusDisplayMap = maritalStatusDisplayMap;
  editProfileDisabledMessage = editProfileDisabledMessage;

  editProfileParameters = {
    show: { value: false },
    contactInfo: { ...initialState },
    onSave: this.onSaveProfile,
    toggleClose: this.closeEditProfileForm
  };
  editCoverageLevelParameters = {
    show: { value: false },
    onSave: this.onSaveCoverageLevel,
    toggleClose: this.closeEditCoverageLevelModal
  };
  isDependentsViewExpanded = false;

  mounted (): void {
    this.userPlanStore.getPlanType();
    this.contactInfoStore.getContactInformation();
    this.initializeFromStateValue();
    this.partnerPortal.getPartnerPortalStatus();
    this.userBankAccountStore.loadBankAccountState();
    this.drivewealthStore.loadAccountSummariesV2({});
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
    this.drivewealthStore.loadAccountClaims({});
    this.hsabInvestmentStore.loadInvestmentAccountStatus({});
    if (this.$route.query.expandDependents) {
      this.isDependentsViewExpanded = true;
    }
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }

  toggleDependents () {
    this.isDependentsViewExpanded = !this.isDependentsViewExpanded;
  }

  get bankAccountLoaded () {
    return this.userBankAccountStore.fetchState === FetchState.Loaded;
  }

  get showBankAccount () {
    return this.bankAccountLoaded && this.userBankAccountStore.accountNumber;
  }

  get isFormLocked () {
    return !this.partnerPortal.hasActiveAccount && !this.userStore.isNotionalDashboardActive;
  }

  get bankAccount () {
    if (this.bankAccountLoaded && this.isBankMasked) {
      return "•".repeat(this.userBankAccountStore.accountNumber.length);
    }

    return this.userBankAccountStore.accountNumber;
  }

  get hsabSsoDeeplinkProfileSummary () {
    return HsabSsoDestination.ProfileSummary;
  }

  get newPasswordVerifyValidation () {
    return {
      required: !!this.passwordFormModel.newPassword,
      confirmed: !!this.passwordFormModel.newPasswordVerify && this.passwordFormModel.newPassword
    };
  }

  get canManageCredentials () {
    if (!this.isHsaBankCustodian) {
      return false;
    }
    return this.userStore.loginMethod !== LoginMethod.Sso;
  }

  get userHasHsabAccount () {
    return this.hsabAccountsStore.userHasHsaAccount;
  }

  get showUndeliverableAddressWarning () {
    return this.formModel.mailingAddress.isUndeliverable === true;
  }

  get profileAddEditEnabled (): boolean {
    if (this.portalFunctionalityDisabled) {
      return false;
    }

    return this.featureFlagStore.flags.bend17261EnableProfileAddEdit;
  }

  get showHsabSsoDeeplinkProfileEditButton () {
    return this.isHsaBankCustodian && !this.profileAddEditEnabled;
  }

  get isHsaBankCustodian () {
    return this.custodianSettingsStore.isHsaBankCustodian;
  }

  get showHsaInfo () {
    return this.showBankAccount;
  }

  get showAuthorizedSignersAndBeneficiaries () {
    return this.isHsaBankCustodian;
  }

  get showDependents () {
    return this.isHsaBankCustodian;
  }

  get fieldEditSettings () {
    return this.contactInfoStore.contactInformation.fieldEditSettings;
  }

  get profileEditSettings () {
    if (!this.fieldEditSettings) {
      return [];
    }

    return [
      this.fieldEditSettings.emailAddress,
      this.fieldEditSettings.homePhone,
      this.fieldEditSettings.mailingAddress,
      this.fieldEditSettings.maritalStatus,
      this.fieldEditSettings.mobileNumber
    ];
  }

  get editProfileDisabled () {
    return !this.profileEditSettings.some(value => value === EmployerEmployeeProfileSettingValue.Edit);
  }

  get coverageLevelUpdateEnabled () {
    if (!this.isHsaBankCustodian) {
      return false;
    }

    if (!this.featureFlagStore.flags.bend19850ProfileCoverageLevelUpdates) {
      return false;
    }

    if (this.bankAccountStore.isBankAccountClosed) {
      return false;
    }

    return this.fieldEditSettings && this.fieldEditSettings.hsaCoverageLevel === EmployerEmployeeProfileSettingValue.Edit;
  }

  togglePasswordRequirements () {
    this.showPasswordRequirements = !this.showPasswordRequirements;
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    this.formModel = clonedModel;
  }

  @Watch("contactInfoStore.contactInformationState")
  initializeFromStateValue () {
    const contactInformation = this.contactInfoStore.contactInformation;
    if (this.contactInfoStore.contactInformationState === FetchState.Loaded && !contactInformation) {
      this.cloneToCurrentModel(initialState);
    } else if (contactInformation) {
      this.cloneToCurrentModel(contactInformation);
    }
  }

  @Watch("contactInfoStore.contactInformation")
  onPlanStateChanged () {
    this.initializeFromStateValue();
  }

  get isLoaded () {
    const accountSummariesV2Loaded = this.drivewealthStore.accountSummariesV2Loaded;

    return this.contactInfoStore.contactInformationState === FetchState.Loaded && accountSummariesV2Loaded;
  }

  get drivewealthAccounts (): DrivewealthAccountSummary[] {
    return this.drivewealthStore.accountSummariesV2;
  }

  toggleBankMask () {
    this.isBankMasked = !this.isBankMasked;
  }

  toggleEditEmail () {
    this.editEmailMode = !this.editEmailMode;
  }

  toggleEditUsername () {
    this.editUsernameMode = true;
  }

  toggleEditPassword () {
    this.editPasswordMode = true;
  }

  onSubmit (): void {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    if (this.isSubmitting) {
      return;
    }

    if (this.formModel.email === this.contactInfoStore.contactInformation.email) {
      return;
    }

    this.$validator
      .validate()
      .then(result => {
        if (!result) {
          return;
        }

        this.contactInfoStore.saveContactInformation(this.formModel).then(() => {
          this.showEmailChangeModal = true;
        }).catch(() => {/* noop */});
      })
      .finally(() => {
        this.isSubmitting = false;
      });
  }

  closePopup () {
    this.showEmailChangeModal = false;
    this.editEmailMode = false;
  }

  updateUsername (): void {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    if (this.updatingUsername) {
      return;
    }

    if (this.formModel.username === this.contactInfoStore.contactInformation.username) {
      this.editUsernameMode = false;
      return;
    }

    this.updatingUsername = true;

    this.$validator
      .validate()
      .then(result => {
        if (!result) {
          return Promise.reject();
        }

        return this.contactInfoStore.updateUserIdpUsername(this.formModel.username);
      })
      .then(() => {
        this.contactInfoStore.getContactInformation();
        this.editUsernameMode = false;
      })
      .catch(() => {/* noop */})
      .finally(() => {
        this.updatingUsername = false;
      });
  }

  updatePassword () {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    if (this.updatingPassword) {
      return;
    }

    this.updatingPassword = true;

    this.$validator
      .validate()
      .then(result => {
        if (!result) {
          return Promise.reject();
        }

        return this.contactInfoStore.updateUserIdpPassword({
          currentPassword: this.passwordFormModel.currentPassword,
          newPassword: this.passwordFormModel.newPassword
        });
      })
      .then(() => {
        this.editPasswordMode = false;
        this.passwordFormModel = { ...passwordInitialState };
      })
      .catch(() => {/* noop */})
      .finally(() => {
        this.updatingPassword = false;
      });
  }

  cancelUsernameUpdate () {
    this.updatingUsername = false;
    this.editUsernameMode = false;
    this.formModel.username = this.contactInfoStore.contactInformation.username;
  }

  cancelPasswordUpdate () {
    this.updatingPassword = false;
    this.editPasswordMode = false;
    this.passwordFormModel = { ...passwordInitialState };
    this.showPasswordRequirements = false;
  }

  togglePasswordMask (inputId: string) {
    const passwordField = document.getElementById(inputId);

    if (passwordField.getAttribute("type") === "password") {
      passwordField.setAttribute("type", "text");
    } else {
      passwordField.setAttribute("type", "password");
    }
  }

  get hasInvestmentAccount (): boolean {
    return this.drivewealthStore.hasAnAccount
     && this.hsabInvestmentStore.investmentAccountStatusLoaded
     && (!this.custodianSettingsStore.isHsaBankCustodian || this.hsabInvestmentStore.investmentAccountStatusLoaded);
  }

  showEditProfileForm () {
    this.editProfileParameters.contactInfo = _.cloneDeep(this.formModel);
    this.editProfileParameters.show.value = true;
  }

  // wait for 200ms before invoking a second request.
  // { leading: true, trailing: false} invokes first request immediately. Trailing or subsequent requests within the wait time i.e 200ms are ignored.
  debouncedSaveProfile = _.debounce(contactInfo => this.contactInfoStore.saveProfile(contactInfo), 200, { leading: true, trailing: false });

  onSaveProfile () {
    return this.debouncedSaveProfile(this.editProfileParameters.contactInfo)
      .then(() => {
        this.editProfileParameters.show.value = false;
      })
      .catch(() => {/*noop*/});
  }

  closeEditProfileForm () {
    this.editProfileParameters.show.value = false;
  }

  showEditCoverageLevelModal () {
    this.editCoverageLevelParameters.show.value = true;
  }

  onSaveCoverageLevel () {
    this.editCoverageLevelParameters.show.value = false;
    this.hsaLimitStore.fetchState = FetchState.Uninitialized;
    this.hsaLimitStore.getHsaAccountLimits();
  }

  closeEditCoverageLevelModal () {
    this.editCoverageLevelParameters.show.value = false;
  }
}
